import React from 'react';
import PropTypes from 'prop-types';

import { H1, Paragraph } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';
import { Container } from 'components/core/Page';
import flowerBlack from 'assets/images/icons/flower-black.svg';
import flowerYellow from 'assets/images/icons/flower-yellow.svg';
import heroCouple from 'assets/images/landing/plp/hero-couple-drive-up.webp';

import './PLPHeroDynamic.scss';

export function PLPHeroDynamic({
	headline,
	storageType,
	handleSearch,
	// sf_14851_sfdc_paid_landing_hero_promo_test
	sf14851Variation,
}) {
	const showControl = sf14851Variation === 'control';
	const showVariation1 = sf14851Variation === 'variation1';
	const showVariation2 = sf14851Variation === 'variation2';

	return (
		<div className={`plp-hero`}>
			{showControl && (
				<div
					className={`plp-hero-dynamic ${storageType} ${sf14851Variation}`}
				>
					<Container>
						<div
							className="hero-searchbox-container"
							id="search-storage"
						>
							<H1
								family="standard"
								size="medium"
								weight="ultraBold"
							>
								{headline}
							</H1>
							<Paragraph
								className="searchbox-description"
								weight="standard"
								color="gray"
								size="standard"
								last
							>
								Find storage deals at 20,000+ locations
							</Paragraph>
							<SearchBox
								id="plp-hero-search-box"
								inputLabel="Enter address, city, or zip"
								handleSearch={handleSearch}
								hideOnScroll
								buttonText="Find Storage"
							/>
						</div>
					</Container>
				</div>
			)}
			{showVariation1 && (
				<div
					className={`plp-hero-dynamic ${storageType} ${sf14851Variation}`}
				>
					<Container>
						<div
							className="hero-searchbox-container"
							id="search-storage"
						>
							<div className="spring-pill">
								<img
									src={flowerBlack}
									alt="flower"
								/>
								Spring Savings!
							</div>
							<div className="promo-container-v1">
								<div className="promo-v1">
									<div className="promo-variation-up-to">
										UP TO
									</div>
									<div className="promo-variation-discount-number">
										25
									</div>
									<div className="promo-variation-discount-type">
										<div className="promo-variation-discount-percent">
											%
										</div>
										<div className="promo-variation-discount-off">
											OFF
										</div>
									</div>
								</div>
								<div className="promo-variation-discount-fine-print">
									* Selected units for a limited time only!
								</div>
							</div>
							<H1
								family="standard"
								size="medium"
								weight="ultraBold"
								color="white"
								className="hero-headline"
							>
								{headline}
							</H1>
							<SearchBox
								id="plp-hero-search-box"
								inputLabel="Enter address, city, or zip"
								handleSearch={handleSearch}
								hideOnScroll
								buttonText="Find Storage"
							/>
							<div className="hero-v1-image"></div>
						</div>
					</Container>
				</div>
			)}
			{showVariation2 && (
				<div
					className={`plp-hero-dynamic ${storageType} ${sf14851Variation}`}
				>
					<Container>
						<div
							className="hero-searchbox-container"
							id="search-storage"
						>
							<div className="spring-pill">
								<img
									src={flowerYellow}
									alt="flower"
								/>
								Spring Savings!
							</div>
							<div className="promo-v2">Up To 25% Off</div>
							<Paragraph
								className="searchbox-description"
								weight="standard"
								color="black"
								size="tall"
								last
							>
								Savings on selected {storageType} units for a{' '}
								<b>limited time only!</b> Compare prices across{' '}
								<b>10,000+</b> storage units
							</Paragraph>
							<SearchBox
								id="plp-hero-search-box"
								inputLabel="Enter address, city, or zip"
								handleSearch={handleSearch}
								hideOnScroll
								buttonText="Find Storage"
							/>
						</div>
						<div className="hero-v2-image">
							<img
								src={heroCouple}
								alt="a couple moving into storage unit"
							/>
						</div>
					</Container>
				</div>
			)}
		</div>
	);
}

PLPHeroDynamic.propTypes = {
	headline: PropTypes.string,
	storageType: PropTypes.string,
	handleSearch: PropTypes.func,
	sf14851Variation: PropTypes.string,
};

export default PLPHeroDynamic;
